var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dp-featured-course box-item" },
    [
      _c(
        _vm.featuredCourse.related_course_content_url && !_vm.isFromSignup
          ? "a"
          : "div",
        {
          tag: "component",
          attrs: {
            href: _vm.featuredCourse.related_course_content_url
              ? _vm.featuredCourse.related_course_content_url
              : undefined
          },
          on: {
            click: function($event) {
              return _vm.trackClick("clicked_course_from_daily_problem")
            }
          }
        },
        [
          _vm.isCourse
            ? [
                _c("div", { staticClass: "image" }, [
                  _c("span", {
                    style: {
                      backgroundImage:
                        "url(" + _vm.featuredCourse.course_image + ")"
                    }
                  })
                ]),
                _vm._v(" "),
                _c("header", [
                  _c("h2", [_vm._v("Featured course")]),
                  _vm._v(" "),
                  _c("h4", [_vm._v(_vm._s(_vm.featuredCourse.course_name))]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.featuredCourse.intro_text) +
                        "\n        "
                    )
                  ]),
                  _vm._v(" "),
                  _vm.featuredCourse.coming_soon
                    ? _c("p", [_vm._v("Coming soon.")])
                    : _vm._e()
                ])
              ]
            : _vm.user.is_staff
            ? _c("p", [
                _c("em", [_vm._v("No course yet for this daily challenge")])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.featuredCourse.chapter_name || _vm.featuredCourse.quiz_title
            ? _c("footer", [
                _vm.featuredCourse.chapter_name
                  ? _c("div", { staticClass: "row" }, [
                      _c("strong", [_vm._v("Chapter:")]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(_vm._s(_vm.featuredCourse.chapter_name))
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.featuredCourse.quiz_title
                  ? _c("div", { staticClass: "row" }, [
                      _c("strong", [_vm._v("Quiz:")]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(_vm._s(_vm.featuredCourse.quiz_title))
                      ])
                    ])
                  : _vm._e()
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.featuredCourse.coming_soon
            ? _c("div", { staticClass: "coming-soon" }, [
                _c("p", [_vm._v("Coming soon.")])
              ])
            : _c("span", { staticClass: "btn btn-outline btn-visit" }, [
                _vm._v("Visit course")
              ])
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }